import React from 'react';

const staticIndicator = (
    <div>Page Loader</div>
);

export default staticIndicator;